// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import loadProducts from "@insite/client-framework/Store/Data/Products/Handlers/LoadProducts";
import { InvoiceLineModel } from "@insite/client-framework/Types/ApiModels";
import { useEffect } from "react";

const sharedParameters: Parameters<typeof loadProducts>[0] = {
    expand: ["variantTraits"],
};

const useLoadLineProductsIfNeededById = (lines: { productId: string | null }[] | undefined | null) => {
    const dispatch = useAppDispatch();
    const productsById = useAppSelector(state => state.data.products.byId);
    const productIds = lines?.reduce((result, line) => {
        if (line.productId && !productsById[line.productId]) {
            return [...result, line.productId];
        }

        return result;
    }, [] as string[]);

    const cacheKey = productIds?.join(",") || "";

    useEffect(() => {
        if (cacheKey) {
            dispatch(loadProducts({ ...sharedParameters, productIds }));
        }
    }, [cacheKey]);
};

export const useLoadInvoiceLineProductsIfNeeded = (lines: InvoiceLineModel[] | undefined | null) => {
    const dispatch = useAppDispatch();
    const productsByPath = useAppSelector(state => state.data.products.idByPath);
    const productNumbers = lines?.reduce((result, line) => {
        if (line.productUri && line.productERPNumber && !productsByPath[line.productUri]) {
            return [...result, line.productERPNumber];
        }

        return result;
    }, [] as string[]);

    const cacheKey = productNumbers?.join(",") || "";

    useEffect(() => {
        if (cacheKey) {
            dispatch(loadProducts({ ...sharedParameters, productNumbers }));
        }
    }, [cacheKey]);
};

export default useLoadLineProductsIfNeededById;
